import { render, staticRenderFns } from "./IconDegree.vue?vue&type=template&id=901e1a6a&"
import script from "./IconDegree.vue?vue&type=script&lang=js&"
export * from "./IconDegree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports